import React, { useState } from 'react';
import LeftMenu from './Sections/LeftMenu';
import RightMenu from './Sections/RightMenu';
import logo from './logo.jpg';
import './Sections/Navbar.css';

function NavBar() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-logo">
          <a href="/" onClick={closeMenu}>
            <img src={logo} alt="Logo" />
          </a>
        </div>

        <div className={`navbar-menu ${isOpen ? 'active' : ''}`}>
          <div className="navbar-left">
            <LeftMenu mode="horizontal" onItemClick={closeMenu} />
          </div>
          <div className="navbar-right">
            <RightMenu mode="horizontal" onItemClick={closeMenu} />
          </div>
        </div>

        <div className="navbar-toggle" onClick={toggleMenu}>
          <span className={`bar ${isOpen ? 'active' : ''}`}></span>
          <span className={`bar ${isOpen ? 'active' : ''}`}></span>
          <span className={`bar ${isOpen ? 'active' : ''}`}></span>
        </div>
      </div>

      {isOpen && <div className="navbar-overlay" onClick={closeMenu}></div>}
    </nav>
  );
}

export default NavBar;